import { sfNames } from 'app/components/access-panel/sf-names';
import { serializeDefaultValues } from 'app/components/access-panel';
import { AccessPanelData } from 'app/components/access-panel/shared/types';

export const serializeAccessData = (accessData: AccessPanelData) => {
  return {
    [sfNames.defaultValues]: serializeDefaultValues(accessData.defaultValues)
  };
};
